import { Checkbox, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useState } from "react";
import NoteButtonTracker from "../NoteButtonTracker";


const SongTracker = () => {

    let [notesShuffled, setNotesShuffled] = useState(false);
    let [notesDisplay, setNotesDisplay] = useState<"double line horizontal" | "vertical" | "horizontal">("horizontal")

    return <Grid container spacing={2}>
        <Grid item xs={1} />
        <Grid item xs={11} container>
            <Grid item xs={2}>
                <FormControlLabel control={<Checkbox checked={notesShuffled} onClick={() => setNotesShuffled(!notesShuffled)} />} label="Ocarina's notes shuffled" />
            </Grid>
            <Grid item xs={4}>
                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">Layout</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                    >
                        <FormControlLabel value="horizontal" control={<Radio />} label="Horizontal" onClick={() => setNotesDisplay("horizontal")} />
                        <FormControlLabel value="vertical" control={<Radio />} label="Vertical" onClick={() => setNotesDisplay("vertical")} />
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={12} container direction="row">
                <NoteButtonTracker areNoteShuffle={notesShuffled} display={notesDisplay} />
            </Grid>
        </Grid>
    </Grid>
}

export default SongTracker